<template>
    <div style="text-align: center">
        <div class="">
            <button class="btn btn-default">Terms and Conditions here!</button>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item"],
    computed: {
    }, 
    methods: {
    }
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/action-items/types/TermsAndConditions.vue